module.exports = __webpack_public_path__ + "static/media/run_9.d5ff9e32.png";